export default __webpack_public_path__ + "static/media/steamMethaneReforming.fe5997d6.svg";